import type { FileData } from '@svoi-ui/interfaces/file-picker'
import { GroupItem } from '@svoi-ui/interfaces/radio'
import { Form } from '~/shared/api'
import { emailRule, emptyRule, requiredIfRule, maxLengthRule } from '~/shared/utils/validation'
import { AgrotechClassPartnerModel, AgrotechClassPartnerSpecializationModel } from '~/model/AccountAgrotechClassPartner'

export const SHOWCASE_MODE_ID = 'showcase'
export const REFUSED_MODE_ID = 'refused'

export const partnerModes: GroupItem[] = [
  {
    id: SHOWCASE_MODE_ID,
    title: 'Разместить компанию/агротехкласс(ы) на витрину*'
  },
  { id: REFUSED_MODE_ID, title: 'Отказаться от размещения на витрине' }
]

export const SHORT_DESCRIPTION_MAX_LENGTH = 2000
export const IMAGES_MAX_COUNT = 6
export const IMAGE_MAX_SIZE_KB = 2048

export default class AccountAgrotechClassPartnerForm extends Form {
  inn: string = ''
  name: string = ''
  mode: GroupItem | null = null
  email: string = ''
  specializations: AgrotechClassPartnerSpecializationModel[] = []
  'short_description': string = ''
  images: Array<File | FileData> = []

  constructor(partner?: AgrotechClassPartnerModel | null) {
    super()
    this.fillForm(partner)
  }

  fillForm(partner?: AgrotechClassPartnerModel | null) {
    this.mode = partner?.is_published ? partnerModes[0] : partnerModes[1]

    if (partner?.inn) {
      this.inn = partner.inn
    }
    if (partner?.name) {
      this.name = partner.name
    }

    this.fillShowcaseFields(partner)
  }

  fillShowcaseFields(partner?: AgrotechClassPartnerModel | null) {
    this.email = partner?.responsiblePersonEmail ?? ''
    this.short_description = partner?.short_description ?? ''
    this.specializations = partner ? [...partner.specializations] : []
    this.images = partner
      ? partner.images.map(i => ({
          id: i.url,
          name: i.name,
          path: i.previewUrl,
          size: Number(i.file_size) || 0
        }))
      : []
  }

  fillCompany(inn: string, name: string) {
    this.inn = this.inn || inn
    this.name = this.name || name
  }

  get isShowcase(): boolean {
    return this.mode?.id === SHOWCASE_MODE_ID
  }

  toInputData() {
    const data = {
      inn: this.inn,
      name: this.name,
      is_published: this.isShowcase,
      responsible_persons: this.email ? [{ email: this.email }] : []
    }

    if (!this.isShowcase) {
      return data
    }

    return {
      ...data,
      short_description: this.short_description,
      specializations: this.specializations.map(i => i.latin),
      images: this.images.length ? this.images.map(i => (i instanceof File ? i : i.id)).filter(Boolean) : null
    }
  }

  static rules(entity: AccountAgrotechClassPartnerForm) {
    return {
      inn: emptyRule,
      name: emptyRule,
      mode: emptyRule,
      email: { ...requiredIfRule(() => entity.isShowcase), ...emailRule },
      short_description: {
        ...requiredIfRule(() => entity.isShowcase),
        ...maxLengthRule(SHORT_DESCRIPTION_MAX_LENGTH)
      },
      specializations: emptyRule,
      images: emptyRule
    }
  }
}
